import React, { useEffect, useRef, useState } from 'react'
import slidenext from "../../Assets/images/slide-next.svg";
import slideback from "../../Assets/images/slide-back.svg";
import { LanguageConstants } from '../../constants/LanguageConstants';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css'; // Import Owl Carousel CSS
import 'owl.carousel/dist/assets/owl.theme.default.css'; // Import Owl Carousel Theme

function Testimonial(props:any) {
  const [data , setData] = useState([])
  const carouselRef = useRef<OwlCarousel>(null); // Explicitly define the type
   const options = {
      loop: false,  
      margin: 10,           
      nav: false,             
      dots: false,            
      autoplay: false,        
      autoplayTimeout: 3000, 
      autoplayHoverPause: true, 
      responsive: {
        0: { items: 1 },      
        480: { items: 2 },     
        768: { items: 3 },     
        1199: { items: 5 }     
      }
    };
    const handleButtonNextClick = () => {
      if (carouselRef.current && carouselRef.current.$ele) {
        carouselRef.current.next(50);
      }
    };
    const handleButtonBackClick = () => {
      if (carouselRef.current && carouselRef.current.$ele) {
        carouselRef.current.prev(50)
      }
    };

   useEffect(()=>{
   if(props?.data){
    setData(props?.data)
   }
   },[props]) 

  return (
    <>
    <section className="testimonials-sec">
        <div className="container">
          <div className="row">
            <div className="col-8">
              <h3 className="blue-heading">{LanguageConstants?.TESTIMONIAL}</h3>
            </div>
            <div className="col-4">
              <div className="d-flex justify-content-end gap-3">
                <div className="testi-arw testi-arw-left" id="testi-left">
                  <img src={slideback} alt="Previous" onClick={handleButtonBackClick} />
                </div>
                <div className="testi-arw testi-arw-rght" id="testi-right">
                  <img src={slidenext} alt="Next"  onClick={handleButtonNextClick} />
                </div>
              </div>
            </div>
          </div>
          <h4 className="what-say">{LanguageConstants?.CLIENTREVIEW}</h4>
        </div>

        <div className="testimonial-slider" id="testimonial-slider">
        <div className='container'>

          {data.length > 0 ?  
         <OwlCarousel className="owl-theme" {...options} ref={carouselRef}>  
         {data.map((res:any , i:any)=>(
           <div className="item" key={i}>
               <div className="testi-card item">
                  <div className="testi-name">{res?.testimonial_details?.title}</div>
                  {/* <div className="testi-profile">Designation</div> */}
                  <p className="testi-comment">{res?.testimonial_details?.content}</p>
                  <div className="testi-rating">
                     {/* <i className="icon-star"></i>
                     <i className="icon-star"></i>
                     <i className="icon-star"></i>
                     <i className="icon-star"></i>
                     <i className="icon-star disabled"></i> */}
                  </div>
               </div>
            </div>
            ))}
          </OwlCarousel>
 :''}
 </div>
            </div>
      </section>
    
    </>
  )
}

export default Testimonial